document.addEventListener('DOMContentLoaded', function() {

  // IE11 Polyfill to support foreach on Node
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  // open/close dropdowns
  document.querySelectorAll('.dropdown a[data-toggle="dropdown"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      var dropdown = anchor.closest('.dropdown');
      var menu = dropdown ? dropdown.querySelector('.dropdown-menu') : null;
      var isAlreadyShown = menu && menu.classList.contains('show');

      document.querySelectorAll('.dropdown-menu').forEach(function(m) {
        if (!menu || m !== menu || isAlreadyShown) {
          m.classList.remove('show');
        }
      });

      if (menu) {
        if (!isAlreadyShown) {
          menu.classList.add('show');
        }
      }
    });
  });

  // language select in footer (in case footer is available)
  var language_select = document.querySelector('.custom-select.language-select');
  if (language_select) {
    language_select.addEventListener('change', function() {
      window.location = this.selectedOptions[0].value;
    });
  }
});
